export const NAV_LINKS = [
    { label: "Accueil", to: "/" },
    { label: "La Méthode Rozier", to: "/methode" },
    { label: "Votre projet", to: "/projet" },
    { label: "Blog & Actualités", to: "/blog" },
    { label: "Contact", to: "/contact" },
];

export const CONTACT_INFO = {
    phone: "+33 6 00 00 00 00",
    email: "contact@rozierconcept.fr",
    zone: "Partout en France",
};
